import React from "react";
import "./App.css";
import TournamentApp from "./components/TournamentApp";

function App() {
  return (
    <div className="App">
      <TournamentApp />
    </div>
  );
}

export default App;
